module.exports = __webpack_public_path__ + "static/media/graphic-dashboard-attach-bank-account@2x.7437a85f.png";